export default __webpack_public_path__ + "static/rma-c6e7af8a618dcbb6e7656252065acd9c.png";